import React, { useEffect, useState } from 'react'
import ReactMapGL, {
  Popup
} from 'react-map-gl'

import config from '../../config'
import locationApi from '../../utils/locationApi'
import Pins from './pins'
import loadingIcon from '../../loading.gif'

const locationUrl = config.api.baseUrl + '/locations/latest'
const branchesUrl = config.api.baseUrl + '/branches'

// Locations/latest
// address: null
// branches: ["PG"]
// createdAt: "2021-05-24T02:36:07.777Z"
// datetime: 1621787820
// idling: false
// ignition: true
// inZone: null
// latitude: 1.476946
// loc: {type: "Point", coordinates: Array(2)}
// longitude: 103.924005
// odometer: 0
// pmId: "sw136"
// reg: "bpr1478"
// speed: 0
// _id: "60aa84ef64af4d7ac94dd76c"

const Map = () => {
  const [data, setData] = useState()
  const [popupInfo, setPopupInfo] = useState(null)
  const [viewport, setViewport] = useState({
    width: '90vw',
    height: '90vh',
    latitude: 3.8382454,
    longitude: 102.3855986,
    zoom: 7
  })

  const colors = {
    PK: '#68C3D4',
    PG: '#568EA3',
    PR: '#CE6C47',
    TEG3: '#628395',
    EC: '#4392F1',
    TEPK: '#90AA86',
    WP: '#4A2545',
    IDEC: '#824C71',
    AW: '#DCCCA3',
    TEBW: '#F26419',
    CB: '#F6AE2D',
    TMBM: '#33658A',
    TMBB: '#2F52E0',
    CBKH: '#FF715B',
    CD: '#8F8073',
    CBPK: '#EAE6E5',
    UK: '#000000'
  }
  useEffect(() => {
    (async () => {
      const resBranches = await locationApi('get', branchesUrl)
      const res = await Promise.all(resBranches.data.map(b => locationApi('get', `${locationUrl}?branchId=${b.name}`)))

      const newData = res
        .map(r => r.data)
        .flat(1)

        .filter(p => (p && p.loc && p.loc.coordinates[0] && p.loc.coordinates[1]))
        .map(p => {
          return {
            id: p.pmId,
            fill: p.branches?.length && colors[p.branches[0]] ? colors[p.branches[0]] : '#000000',
            latitude: p.loc.coordinates[0],
            longitude: p.loc.coordinates[1],
            branches: p.branches
          }
        })

      console.log('--------data', JSON.stringify(newData))
      setData(newData)
    })()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!data) {
    return (<img src={loadingIcon} alt='loading...' />)
  }

  const mapType = viewport.zoom > 16 ? 'satellite-v9' : 'light-v8'

  return (
    <>
      <ReactMapGL
        {...viewport}
        mapStyle={`mapbox://styles/mapbox/${mapType}`}
        onViewportChange={(viewport) => setViewport(viewport)}
      >
        <Pins data={data} onClick={setPopupInfo} />

        {popupInfo && (
          <Popup
            tipSize={5}
            anchor='top'
            longitude={popupInfo.longitude}
            latitude={popupInfo.latitude}
            closeOnClick={false}
            onClose={setPopupInfo}
          >
            <span>{popupInfo.id} - [{popupInfo.branches.join(',')}]</span>
          </Popup>
        )}
      </ReactMapGL>
    </>
  )
}

export default Map
